module.exports = __webpack_public_path__ + "static/media/vergnano-logo.7e8844c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vergnano-logo.jpg
// module id = 748
// module chunks = 0